import { render } from "./VideoCircle.vue?vue&type=template&id=6317e0b0&ts=true&lang=pug"
import script from "./VideoCircle.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoCircle.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__